import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EventsModel } from '../models/events.model';
import { GeneralHelper } from '../helpers/general.helper';

@Injectable({
  providedIn: 'root'
})
export class EventsRepository {

  private apiUrl: string = environment.apiUrl;

  constructor(
    private httpClient: HttpClient,
    private generalHelper: GeneralHelper
  ) { }

  public getByQuery(category?: string, subCategory?: string): Observable<{ events: Array<EventsModel> }> {
    return this.httpClient.get<{ events: Array<EventsModel> }>(`${this.apiUrl}/PDV/loadEventsSite?category=${category}`);
  }

  public getCities(): Observable<Array<any>> {
    return this.httpClient.get<Array<any>>(`${this.apiUrl}/activecities`);
  }


  public list2site(params: any) {
    let query = this.generalHelper.buildQuery(params);
    return this.httpClient.get<any>(`${this.apiUrl}/PDV/loadEventSite?${query}`);
  }

  public getMap(params: any) {
    let query = this.generalHelper.buildQuery(params);
    return this.httpClient.get<any>(`${this.apiUrl}/pdv/map/place/canvas?${query}`);
  }


  public getOrders(id: any) { 
    return this.httpClient.get<any>(`${this.apiUrl}/order?id[]=${id}&forPaymentChange=true`);
  }



}
